<template>
    <div id="page" style="background-color: rgba(248, 248, 248, 1);">
        <div class="container">
            <img src="~@/assets/images/menu/低碳声明.png" style="width: 100%;"/>
        </div>
        <section class="section" style="padding: 0;" >
            <div class="container">
                <div class="row" style="padding:20px 0;" v-show="active==key[0]">
                    <template  v-for="(item,index) in list">
                        <router-link  :key="index" :to="{ path:'/biaoqian/articleDetail',query:{id:item.id} }">
                            <div class="col-lg-12" >
                                <div class="text-tip-2"><span style="color:rgba(1, 90, 177, 1);font-weight: 400;">{{item.title}}</span><span>{{getSpecialTime(item.releaseTime,"yyyy-MM-dd")}}</span></div>
                            </div>
                        </router-link>
                    </template>
                    <div class="mt-3">
                        <b-pagination v-model="page.currentPage" :total-rows="page.rows" align="right"></b-pagination>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {articleList} from "@/api/home"
    import {getSpecialTime}  from "@/utils/tools"
    export default {
        name: "menu1_1",
        data() {
            return {
                active:"标准化要闻",
                page:{
                    rows:0,
                    currentPage:1
                },
                key:["标准化要闻","政府奖励奖金","碳标签资讯","标准制定问答","标准制定公告"],
                list:[]
            }
        },
        components: {},
        watch: {},
        mounted() {
            console.log("this.$route.params",this.$route.query)
            this.articleList()
        },
        created() {

        },
        methods: {
            getSpecialTime,
            activeChange(value){
                this.active=value
            },
            articleList(){
                let data={
                    parentTitle:"碳标签-标准制定",sonTitle:"碳标签-低碳产品声明"
                }
                articleList(data).then(res=>{
                    console.log(res)
                    this.list = res.data.records
                    this.page.rows=res.data.total
                })
            }
        }
    }
</script>

<style scoped>

    .container{
        width: 1200px;
        min-width: 375px;
    }
    .active-nav{
        height: 70px;
        background-color: rgba(2, 171, 57, 1);
        color: #ffffff;
    }
    .active-nav-1{
        height: 70px;
        line-height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .list-content{
        width: 285px;
        background-color: #ffffff;
        padding-bottom:10px;
        margin-bottom: 15px;
    }
    .text-tip-1{
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 20px;
        color: #000000;
        line-height: 30px;
        padding: 10px 10px 5px 10px;
        height: 100px;
        line-height: 30px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3; /* 定义文本的行数 */
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .text-tip-2{
        padding: 5px 10px;
        display: flex;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 200;
        font-size: 16px;
        color: #888888;
        line-height: 30px;
    }
    .text-tip-2 span{
        flex:1;
    }
    .text-tip-2 span:nth-child(2){
        text-align: right;
    }
</style>
